import React from 'react';
import { useNavigate } from 'react-router-dom';
import { UserLayout } from '../layout';
import EndroitDetailContent from './EndroitDetailContent';

const DASHBOARD_PAGE_KEY = 'cabaza_dashboard_page';

/**
 * Dashboard Endroit Detail Page
 * Full page with layout (header, menu, content, footer)
 */
const EndroitDetail = ({ onLogout }) => {
    const navigate = useNavigate();

    // Get the current dashboard page from localStorage to highlight correct menu item
    const currentDashboardPage = localStorage.getItem(DASHBOARD_PAGE_KEY) || 'endroits';

    // Handle navigation from menu - save page and go to dashboard
    const handleNavigate = (page) => {
        localStorage.setItem(DASHBOARD_PAGE_KEY, page);
        navigate('/');
    };

    return (
        <UserLayout
            currentPage={currentDashboardPage}
            onNavigate={handleNavigate}
            onLogout={onLogout}
        >
            <EndroitDetailContent />
        </UserLayout>
    );
};

export default EndroitDetail;
